import {getMethod} from '~/api'

async function get() {
    return await getMethod('/cms/home-page-settings')
}

export {get}
